module.exports = __webpack_public_path__ + "img/invoice2_1.bf9d3ff9.svg";